class FloatTime {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;

    this.instance.addTaskLayer(task => {
      if (!this.instance.config.show_float_time) return;
      const slack = instance.getFreeSlack(task);

      if (!slack) {
        return null;
      }

      const state = instance.getState().drag_mode;

      if (state == 'resize' || state == 'move') {
        return null;
      }
      if (task.type === instance.config.types.button) {
        return null;
      }

      let slackStart = task.end_date;
      let slackEnd = instance.calculateEndDate({
        start_date: task.end_date,
        duration: slack,
        unit: instance.config.duration_unit,
        task,
      });

      if (instance.config.durationData.mode !== 'hour') {
        const calendar = instance.getCalendar(task.gantt_id);

        slackStart = instance.scaleWeekDate(instance.scaleDayDate(slackStart, calendar));
        slackEnd = instance.scaleWeekDate(instance.scaleDayDate(slackEnd, calendar));
      }
      const sizes = instance.getTaskPosition(task, slackStart, slackEnd);
      const el = document.createElement('div');

      el.className = task.type === instance.config.types.project ? 'slack slack--project' : 'slack';
      el.style.left = `${sizes.left - 1}px`;
      const height = sizes.height;
      // Baseline doubles config.row_height; center slack in the upper task band using the same numbers as the grid (all view modes).
      const rowHeightForPadding = instance.config.baseline > 0 && instance.config.original_row_height
        ? instance.config.original_row_height
        : instance.config.row_height;
      const heightForPadding = instance.config.baseline > 0
        && instance.config.bar_height
        && task.type !== instance.config.types.milestone
        ? instance.config.bar_height
        : height;
      let padd = Math.floor((rowHeightForPadding - heightForPadding) / 2);

      if (task.type === instance.config.types.milestone && instance.config.link_line_width > 1) {
        padd += 1;
      }

      // Compact + baseline: bar/slack sit ~2px lower than the visual task bar (skin/border rounding).
      const baselineTopNudge =
        instance.config.baseline > 0 && instance.config.view_mode === 'compact' ? -2 : 0;

      el.style.top = `${sizes.top + padd + baselineTopNudge}px`;
      el.style.width = `${sizes.width}px`;
      el.style.height = `${sizes.height}px`;
      el.setAttribute('data-id', task.id);

      return el;
    });
  }
}
export default new FloatTime();
